import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ajaxFuelCategories from "../../util/remote/ajaxFuelCategories";
import ajaxStations from "../../util/remote/ajaxStations";
const RegisterFuelCategoryModal = (props) => {
  const station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const [loading, setLoading] = useState(false);
  const [stationID, setstationID] = useState(station_idd);
  const [categoryName, setcategoryName] = useState("");
  const allRowsFilled = () => categoryName && stationID;
  // submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const data = {
      fuel_category: categoryName,
      station_id: stationID,
    };
    setLoading(true);
    const response = await ajaxFuelCategories.create_fuel_category(data);
    setLoading(false);
    if (response.status === "OK") {
      props.func();
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setcategoryName("");
    setstationID("");
  };
  const [stations_list, setstations_list] = useState([]);
  const fetchStations = async () => {
    setLoading(true);
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: Number(d.id),
          label: d.station_name,
        }));
      setstations_list(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchStations();
  }, []);
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleAdd(e, controls.close)}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Register Fuel Category"}
      </button>
    </>
  );
  return (
    <SystemModal title="Creating Fuel Category" size="md" footer={RenderFooter}>
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register Fuel Station</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Owner */}
                    <div className="col-md-12">
                      <label>
                        select Station <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={stations_list}
                        isDisabled
                        value={stations_list.find((x) => x.value === stationID)}
                        onChange={(selected) => setstationID(selected.value)}
                        placeholder="Select station group"
                      />
                    </div>
                    {/* Station Name */}
                    <div className="col-md-12">
                      <label>
                        Fuel Category name
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={categoryName}
                        onChange={(e) => setcategoryName(e.target.value)}
                        className="form-control"
                        placeholder="Fuel category  name e.g petro, diesel"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterFuelCategoryModal;
